<template>
  <input type="file" data-testid="file-model-input" @change="handleFileChange" />
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';

const props = defineProps({
  value: {
    type: File as unknown as () => File | undefined,
    default: undefined
  }
});

const emit = defineEmits<{
  'input': [value: File | undefined];
}>();

// Reactive data
const internalValue = ref<File | undefined>(props.value);

// Methods
const handleFileChange = (event: Event): void => {
  const input = event.target as HTMLInputElement;
  const file = input.files?.[0];
  internalValue.value = file;
};

// Watchers
watch(() => props.value, (newVal: File | undefined) => {
  internalValue.value = newVal;
});

watch(internalValue, (newVal: File | undefined) => {
  emit('input', newVal);
});
</script>

<style scoped>
/* Add any specific styling for file input here */
</style>
